import { createReducer, on } from "@ngrx/store"
import { ChargerConfigurationState } from "./charger.configuration.store.models"
import * as chargerConfigurationActions from "./charger.configuration.store.actions";

export const initialChargerConfigurationState: ChargerConfigurationState = {
    chargerId: null,
    chargerConfiguration: null,
    loading: false,
    error: null,
    deviceConfiguration: null,
    savingExternalCentralSystemConfig: false,
    savingDeviceDetails: false,
    savingAuthTypes: false,
    savingDeviceConfig: false,
    waitingForConfigReload: false,
    waitingRequestId: null,
    waitingForConfigSave: false
}

export const chargerConfigurationReducer = createReducer(
    initialChargerConfigurationState,
    on(chargerConfigurationActions.loadChargerConfigurationDetails, (state, { chargerId }) => ({
        ...state,
        loading: true,
        chargerId
    })),
    on(chargerConfigurationActions.loadChargerConfigurationDetailsSuccess, (state, { chargerConfiguration, deviceConfig }) => ({
        ...state,
        loading: false,
        chargerConfiguration,
        deviceConfiguration: deviceConfig
    })),
    on(chargerConfigurationActions.loadChargerConfigurationDetailsFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error: error?.errorMessage ?? 'ERROR'
    })),
    on(chargerConfigurationActions.saveExternalCentralSystemConfiguration, (state) => ({
        ...state,
        loading: true,
        savingExternalCentralSystemConfig: true
    })),
    on(chargerConfigurationActions.saveExternalCentralSystemConfigurationSuccess, (state, { data }) => ({
        ...state,
        loading: false,
        savingExternalCentralSystemConfig: false,
        chargerConfiguration: {
            ...state.chargerConfiguration!,
            acceptAnyPassword: data.acceptAnyPassword ?? false,
            chargerPassword: data.password,
            externalCentralSystem: { 
                externalCentralSystemUrl: data.externalCentralSystemUrl ?? '',
                externalId: data.externalId
             }

        }
    })),
    on(chargerConfigurationActions.saveExternalCentralSystemConfigurationFailure, (state, { error }) => ({
        ...state,
        loading: false,
        savingExternalCentralSystemConfig: false,
        error: error?.errorMessage ?? 'ERROR'
    })),
    on(chargerConfigurationActions.saveChargerDeviceDetails, (state) => ({
        ...state,
        loading: true,
        savingDeviceDetails: true
    })),
    on(chargerConfigurationActions.saveChargerDeviceDetailsSuccess, (state, { deviceDetails }) => ({
        ...state,
        loading: false,
        savingDeviceDetails: false,
        chargerConfiguration: {
            ...state.chargerConfiguration!,
            deviceDetails: { ...deviceDetails }
        }
    })),
    on(chargerConfigurationActions.saveChargerDeviceDetailsFailure, (state, { error }) => ({
        ...state,
        loading: false,
        savingDeviceDetails: false,
        error: error?.errorMessage ?? 'ERROR'
    })),
    on(chargerConfigurationActions.saveAuthType, (state) => ({
        ...state,
        loading: true,
        savingAuthTypes: true
    })),
    on(chargerConfigurationActions.saveAuthTypeSuccess, (state, { authType }) => ({
        ...state,
        loading: false,
        savingAuthTypes: false,
        chargerConfiguration: {
            ...state.chargerConfiguration!,
            authenticationTypes: { ...authType }
        }
    })),
    on(chargerConfigurationActions.saveAuthTypeFailure, (state, { error }) => ({
        ...state,
        loading: false,
        savingAuthTypes: false,
        error: error?.errorMessage ?? 'ERROR'
    })),
    on(chargerConfigurationActions.realodFullConfigurationRequestPending, (state, { requestId }) => ({
        ...state,
        waitingForConfigReload: true,
        waitingRequestId: requestId!
    })),
    on(chargerConfigurationActions.reloadFullConfigurationSuccess, (state, { chargerConfig }) => ({
        ...state,
        waitingForConfigReload: false,
        deviceConfiguration: {...chargerConfig}
    })),
    on(chargerConfigurationActions.saveConfigurationPending, (state, { requestId }) => ({
        ...state,
        loading: false,
        waitingRequestId: requestId!,
        waitingForConfigReload: true
    })),
    // on(chargerConfigurationActions.saveConfigurationSuccess, (state, { chargerConfig }) => ({
    //     ...state,
    //     waitingRequestId: null,
    //     waitingForConfigReload: false,
    //     deviceConfiguration: {
    //         ...state.deviceConfiguration!,
    //         configurationKey: ChargerConfigurationUtil.getPatchedConfigurationKeys(
    //             state.deviceConfiguration?.configurationKey, chargerConfig.configurationKey
    //         )
    //     }
    // })),
    on(chargerConfigurationActions.saveConfiguration, (state) => ({
        ...state,
        waitingRequestId: null,
        waitingForConfigReload: false,
        waitingForConfigSave: true,
        loading: true
    })),
    on(chargerConfigurationActions.saveConfigurationFailure, (state, { error }) => ({
        ...state,
        waitingRequestId: null,
        waitingForConfigReload: false,
        waitingForConfigSave: false,
        loading: false,
        error: error?.errorMessage ?? "ERROR"
    })),
    on(chargerConfigurationActions.loadDeviceConfigurationFromDb, (state) => ({
        ...state,
        waitingRequestId: null,
        waitingForConfigReload: true,
        waitingForConfigSave: false
    })),
    on(chargerConfigurationActions.loadDeviceConfigurationFromDbSuccess, (state, { deviceConfiguration }) => ({
        ...state,
        waitingForConfigReload: false,
        deviceConfiguration: deviceConfiguration
    })),
    on(chargerConfigurationActions.loadDeviceConfigurationFromDbFailure, (state, { error }) => ({
        ...state,
        error: error?.errorMessage ?? "ERROR"
    }))
)